/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings">;
    readonly " $refType": "LocalReplyListContainer_settings";
};
export type LocalReplyListContainer_settings$data = LocalReplyListContainer_settings;
export type LocalReplyListContainer_settings$key = {
    readonly " $data"?: LocalReplyListContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocalReplyListContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '518fe545321c804c20e7e2f640fb82e5';
export default node;
